import { UnauthenticatedApp } from "UnauthenticatedApp";
import "core-js";
import "trix";
import "trix/dist/trix.css";
import "@nexl-lts/ui/theme/tokens.css";
import "@nexl-lts/ui/theme/tokens.dark.css";
import "./i18n";
import React from "react";
import { createRoot } from "react-dom/client";
import { buildApolloHostConfig } from "services/apolloHostAdapter";
import introspectionResult from "__generated__/fragment_matcher_unauthenticated";

document.addEventListener("DOMContentLoaded", () => {
  const mainDom = document.getElementById("react-main");
  if (mainDom) {
    const apolloHostConfig = buildApolloHostConfig();
    apolloHostConfig.possibleTypes = introspectionResult.possibleTypes;
    const root = createRoot(mainDom);
    root.render(<UnauthenticatedApp apolloHostConfig={apolloHostConfig} />);
  }
});
